export const brandParentIds = [555, 1340, 1361, 8420, 5526, 2373];
export const mensNewIn = "cat/?cid=27110";
export const womensNewIn = "cat/?cid=27108";
